<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12" style="text-align: center;">
      @if (errorMsg) {
        <div class="alert alert-danger">
          {{errorMsg}}
        </div>
      }
    </div>
  </div>
</div>
